// extracted by mini-css-extract-plugin
export default {"text":"AnalyticsItem_text__d3OpE","barContainer":"AnalyticsItem_barContainer__NH0Em","bar":"AnalyticsItem_bar__IZXJp"};